import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const PowerBIIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <g clipPath="url(#clip0_24530_73504)">
      <path
        d="M16.7144 0H11.4128C10.9569 0 10.5874 0.369543 10.5874 0.825397V19.1746C10.5874 19.6305 10.9569 20 11.4128 20H16.7144C17.1702 20 17.5398 19.6305 17.5398 19.1746V0.825397C17.5398 0.369543 17.1702 0 16.7144 0Z"
        fill="url(#paint0_linear_24530_73504)"
      />
      <g filter="url(#filter0_d_24530_73504)">
        <path
          d="M13.4446 19.1746V20H12.6192H7.31759C6.86173 20 6.49219 19.6305 6.49219 19.1746V5.80953C6.49219 5.35367 6.86173 4.98413 7.31759 4.98413H12.6192C13.0751 4.98413 13.4446 5.35367 13.4446 5.80953V19.1746Z"
          fill="black"
        />
      </g>
      <path
        d="M13.4446 19.1746V20H12.6192H7.31759C6.86173 20 6.49219 19.6305 6.49219 19.1746V5.80953C6.49219 5.35367 6.86173 4.98413 7.31759 4.98413H12.6192C13.0751 4.98413 13.4446 5.35367 13.4446 5.80953V19.1746Z"
        fill="url(#paint1_linear_24530_73504)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.41283 19.1746V20H8.58743H3.28585C2.82999 20 2.46045 19.6305 2.46045 19.1746V10.8254C2.46045 10.3695 2.82999 10 3.28585 10H8.58743C9.04329 10 9.41283 10.3695 9.41283 10.8254V19.1746Z"
        fill="url(#paint2_linear_24530_73504)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_24530_73504"
        x="6.49219"
        y="-5.01587"
        width="46.9526"
        height="55.0159"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="20" dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0530212 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_24530_73504"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_24530_73504"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_24530_73504"
        x1="14.0636"
        y1="0"
        x2="14.0636"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBBB14" />
        <stop offset="1" stopColor="#B25400" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_24530_73504"
        x1="9.96839"
        y1="4.98413"
        x2="9.96839"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9E583" />
        <stop offset="1" stopColor="#DE9800" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_24530_73504"
        x1="5.93664"
        y1="10"
        x2="5.93664"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9E68B" />
        <stop offset="1" stopColor="#F3CD32" />
      </linearGradient>
      <clipPath id="clip0_24530_73504">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
